import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
export const dataGridProps = {
        localeText: {
        toolbarExport: 'Descargar',
        toolbarExportCSV: 'Descargar CSV',
        toolbarExportPrint: 'Imprimir',
        noRowsLabel: 'Sin resultados',
        noResultsOverlayLabel: 'No se encontraron resultados',
        footerPaginationRowsPerPage: 'Resultados por página',
        footerPaginationLabelDisplayedRows: ({ from, to, count }) =>
            `${from} - ${to} de ${count !== -1 ? count : `más de ${to}`}`,
        // Customizing toolbar labels
        toolbarColumns: 'Columnas', // Changes "Columns"
        toolbarFilters: 'Filtros',  // Changes "Filters"
        toolbarDensity: 'Densidad', // Changes "Density"
        toolbarDensityCompact: 'Compacta',
        toolbarDensityStandard: 'Estándar',
        toolbarDensityComfortable: 'Cómoda',
    },
    slots:{ toolbar: GridToolbar },
    slotProps:
    {
        toolbar:
        {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500, placeholder: 'Buscar' },
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: false },
        },
    },
};
